<template>
  <div>
    <!-- banner -->
    <div class="message-banner" :style="cover">
      <!-- 弹幕输入框 -->
      <div class="message-container">
        <h1 class="message-title">留言板</h1>
        <p class="message-tip">
          #此页面为留言板，使用AI问答请前往
          <router-link to="/ai/chatgpt" style="color: #1976d2"
            >"AI问答"页面</router-link
          >
        </p>
        <el-row>
          <div class="message-input-wrapper">
            <el-input
              v-model="content"
              @keyup.enter="addToList"
              placeholder="输入留言"
            >
              <template slot="prepend">
                <el-upload
                  class="avatar-uploader"
                  :show-file-list="false"
                  ref="upload"
                  name="filedatas"
                  :action="uploadPictureHost"
                  :before-upload="uploadBefore"
                  :http-request="uploadSectionFile"
                  multiple
                >
                  <i class="imageUploadBtn el-icon-picture-outline"></i>
                </el-upload>
              </template>
            </el-input>
            <button class="ml-3" @click="addToList" v-show="show">发送</button>
          </div>
        </el-row>
        <el-row v-if="this.uploadImageUrl" class="message-image-row">
          <img
            style="
              border-radius: 4px;
              width: 120px;
              height: 120px;
              object-fit: cover;
            "
            :src="this.uploadImageUrl"
            class="imgAvatar"
          />
          <i
            class="imagmessage-image-hover-icon UploadBtn el-icon-delete"
            @click="clearImage()"
          ></i>
        </el-row>
      </div>
      <!-- 弹幕列表 -->
      <div :class="geBarrageContainerClass()">
        <div v-for="item of barrageList" :key="item.id">
          <div class="info-wrapper">
            <span class="barrage-items">
              <img
                :src="item.avatar"
                width="30"
                height="30"
                style="border-radius: 50%; min-width: 30px"
              />
              <div class="msgItemCol">
                <v-col>
                  <v-row class="headRow">
                    <span class="nickname">{{ item.nickname }} </span>
                    <span class="fenge"></span>
                    <span class="datetime">{{ item.createTime | date }}</span>
                  </v-row>
                  <v-row class="contentRow">
                    <span class="content">{{ item.content }}</span>
                  </v-row>
                  <v-row v-if="item.uploadImageUrl" class="contentRowImg">
                    <span class="contentImgSpan"
                      ><img
                        class="contentImg"
                        :src="item.uploadImageUrl"
                        @click="previewURL(item.uploadImageUrl)"
                    /></span>
                  </v-row>
                </v-col>
              </div>
              <span
                class="contentDot"
                :style="'background:' + stringToColour(item.content)"
              >
              </span>
            </span>
          </div>
        </div>
        <!-- 无限加载 -->
        <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
          <div slot="no-more" />
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script>
import { api as viewerApi } from "v-viewer";
import { upload, listMessage, addMessage } from "../../api";
export default {
  metaInfo: {
    meta: [
      {
        name: "keyWords",
        content:
          "兮游,seayouth,兮游博客,seayouth博客,chatgpt,AI绘图,AI作品图集,AI语音,游戏模拟器", //变量或字符串
      },
      {
        name: "description",
        content:
          "一个专注于AI技术分享的博客平台,无论您是AI爱好者、学者、开发者，还是对AI应用有兴趣的读者，这里都能为您提供有价值的内容和思考",
      },
    ],
  },
  mounted() {},
  data() {
    return {
      sourceImageURLs: [],
      uploadPictureHost: process.env.VUE_APP_BASE_API + "/file/upload",
      show: true,
      img: process.env.VUE_APP_IMG_API,
      content: "",
      count: null,
      barrageList: [],
      params: {
        pageNo: 1,
        pageSize: 20,
      },
      uploadImageUrl: "",
    };
  },
  methods: {
    previewURL(src) {
      this.sourceImageURLs = [];
      this.sourceImageURLs.push(src);
      const $viewer = viewerApi({
        options: {
          navbar: false,
          toolbar: false,
          title: false,
          inline: true,
          button: true,
          tooltip: false,
          movable: true,
          zoomable: true,
          rotatable: true,
          scalable: true,
          transition: true,
          fullscreen: true,
          keyboard: false,
        },
        images: this.sourceImageURLs,
      });
    },
    geBarrageContainerClass() {
      if (this.uploadImageUrl) {
        return "barrage-container-show-img";
      } else {
        return "barrage-container";
      }
    },
    uploadBefore: function() {
      this.openLoading();
    },
    uploadSectionFile: function(param) {
      this.files = param.file;
      // FormData 对象
      var formData = new FormData();
      // 文件对象
      formData.append("multipartFile", this.files);
      upload(formData)
        .then((res) => {
          this.uploadImageUrl = res.data;
          // this.$toast({ type: "success", message: "上传成功" });
        })
        .catch((err) => {
          this.$notify({
            message: err.message,
            type: "error",
            showClose: true,
            position: "bottom-right",
            duration: 0,
          });
          // this.$toast({ type: "error", message: err.message });
        });
      this.loading.close();
    },
    // 打开加载层
    openLoading: function() {
      this.loading = this.$loading({
        lock: true,
        text: "正在加载中~",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    stringToColour(str) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      var colour = "#";
      for (var i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 0xff;
        colour += ("00" + value.toString(16)).substr(-2);
      }
      return colour;
    },
    infiniteHandler($state) {
      listMessage(this.params).then((res) => {
        if (res.data.records.length) {
          res.data.records.forEach((item) => {
            this.barrageList.push(item);
          });
          this.params.pageNo++;
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    addToList() {
      if (this.count) {
        this.$notify({
          message: "30秒后才能再次留言",
          type: "warning",
          showClose: false,
          position: "bottom-right",
          duration: 2000,
        });
        // this.$toast({ type: "error", message: "30秒后才能再次留言" });
        return false;
      }
      console.log(this.content);
      console.log(this.uploadImageUrl);
      if (
        (this.content == null || this.content.trim() == "") &&
        (this.uploadImageUrl == null || this.uploadImageUrl.trim() == "")
      ) {
        this.$notify({
          message: "留言不能为空",
          type: "warning",
          showClose: false,
          position: "bottom-right",
          duration: 2000,
        });
        // this.$toast({ type: "error", message: "留言不能为空" });
        return false;
      }
      const userAvatar = this.$store.state.avatar
        ? this.$store.state.avatar
        : this.$store.state.blogInfo.webSite.touristAvatar;
      const userNickname = this.$store.state.nickname
        ? this.$store.state.nickname
        : "游客";
      var message = {
        avatar: userAvatar,
        status: 1,
        nickname: userNickname,
        content: this.content,
        uploadImageUrl: this.uploadImageUrl,
        time: Math.floor(Math.random() * (10 - 7)) + 8,
      };
      this.barrageList.unshift(message);
      this.content = "";
      addMessage(message).then((res) => {
        // this.barrageList=[]
        this.uploadImageUrl = null;
        // this.params.pageNo=1
        // if(this.$refs.infiniteLoading){
        //   this.$refs.infiniteLoading.stateChanger.reset();
        // }
      });
    },
    listMessage() {
      listMessage(this.params).then((res) => {
        this.barrageList = res.data.records;
      });
    },
    clearImage() {
      this.uploadImageUrl = null;
    },
  },
  computed: {
    cover() {
      var cover = "";
      this.$store.state.blogInfo.pageList.forEach((item) => {
        if (item.pageLabel == "message") {
          cover = item.pageCover;
        }
      });
      return "background: url(" + cover + ") center center / cover no-repeat";
    },
  },
};
</script>

<style scoped>
.message-banner {
  /* position: absolute;
  top: -60px;
  left: 0;
  right: 0; */
  /* height: 100vh; */
  background-color: #49b1f5;
  animation: header-effect 1s;
}
.message-input-wrapper {
  display: flex;
  justify-content: center;
  height: 2.5rem;
  margin-top: 2rem;
}
.message-input-wrapper .el-input {
  outline: none;
  width: 70%;
  border-radius: 20px;
  height: 100%;
  padding: 0 1.25rem;
}
.message-image-row {
  margin-top: 12px;
  position: relative;
  left: 8%;
  float: left;
  border: 1px dashed #aaaaaa;
  padding: 4px 4px 0px;
}
:deep(.message-input-wrapper .el-input__inner) {
  background: none;
  border: none;
  color: #333;
}
:deep(.el-input-group__append),
:deep(.el-input-group__prepend) {
  background-color: #ffffff00;
  border: none !important;
  padding: 0px 4px !important;
}
.message-input-wrapper .el-input::-webkit-input-placeholder {
  color: #333;
}
.message-input-wrapper button {
  outline: none;
  border-radius: 20px;
  height: 100%;
  padding: 0 1.25rem;
}

.theme--light.v-application .message-title {
  color: #111;
}
.theme--dark.v-application .message-title {
  color: #eee;
}
.theme--light.v-application .message-input-wrapper .el-input {
  color: #333;
  border: rgba(0, 0, 0, 0.38) 1px solid;
}
.theme--dark.v-application .message-input-wrapper .el-input {
  color: #ccc;
  border: rgba(255, 255, 255, 0.38) 1px solid;
}
.theme--light.v-application .message-input-wrapper button {
  border: rgba(0, 0, 0, 0.38) 1px solid;
}
.theme--dark.v-application .message-input-wrapper button {
  color: #ccc;
  border: rgba(255, 255, 255, 0.38) 1px solid;
}
.theme--light.v-application .barrage-container {
  box-shadow: 0 4px 8px 6px rgba(7, 17, 27, 0.06);
  background: #fff;
  color: #4c4948;
}
.theme--dark.v-application .barrage-container {
  box-shadow: 0 4px 8px 6px rgb(208 212 217 / 1%);
  background: #0d0d0d78;
  color: #4c4948;
}
.theme--dark.v-application .info-wrapper {
  border-bottom: #25252500 1px dashed;
}
.theme--dark.v-application .info-wrapper:hover {
  background-color: #0d0d0d45;
}
.theme--light.v-application .barrage-items {
  background: rgb(240 240 240 / 36%);
  color: #fff;
}
.theme--dark.v-application .barrage-items {
  background: rgb(18 18 18);
  color: #fff;
}
.theme--light.v-application .content {
  color: #000000bd;
}
.theme--dark.v-application .content {
  color: #eeeeeebd;
}
@media (min-width: 760px) {
  .message-title {
    font-size: 4rem;
    animation: title-scale 1s;
  }
  .message-container {
    position: relative;
    width: 640px;
    top: 20px;
    left: 0;
    right: 0;
    text-align: center;
    margin: 0 auto;
    color: #333;
  }
  .barrage-container {
    position: relative;
    /* top: 120px; */
    /* left: 0; */
    /* right: 0; */
    /* bottom: 0; */
    width: 100%;
    /* overflow-x: hidden; */
    /* overflow-y: auto; */
    padding: 32px 20px;
    bottom: 20px;
    /* height: calc(100% - 240px); */
    max-width: 970px;
    border-radius: 8px;
    margin: 80px auto 40px auto !important;
  }
  .barrage-container-show-img {
    position: relative;
    /* top: 120px; */
    /* left: 0; */
    /* right: 0; */
    /* bottom: 0; */
    width: 100%;
    /* overflow-x: hidden; */
    /* overflow-y: auto; */
    padding: 32px 20px;
    bottom: 20px;
    /* height: calc(100% - 240px); */
    background-color: #fff;
    max-width: 970px;
    background: #fff;
    color: #4c4948;
    border-radius: 8px;
    margin: 160px auto 40px auto !important;
  }
  .contentImg {
    border-radius: 12px;
    max-width: 600px;
    margin: 10px;
  }
}
@media (max-width: 759px) {
  .message-title {
    color: #111;
    font-size: 3rem;
    animation: title-scale 1s;
  }
  .message-container {
    position: relative;
    width: 360px;
    top: 20px;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 5;
    margin: 0 auto;
    color: #333;
  }
  .barrage-container {
    position: relative;
    /* top: 120px; */
    /* left: 0; */
    /* right: 0; */
    /* bottom: 0; */
    width: 100%;
    /* overflow-x: hidden; */
    /* overflow-y: auto; */
    padding: 32px 20px;
    bottom: 20px;
    /* height: calc(100% - 240px); */
    background-color: #fff;
    max-width: 970px;
    background: #fff;
    color: #4c4948;
    border-radius: 8px;
    box-shadow: 0 4px 8px 6px rgba(7, 17, 27, 0.06);
    margin: 80px auto 40px auto !important;
  }
  .barrage-container-show-img {
    position: relative;
    /* top: 120px; */
    /* left: 0; */
    /* right: 0; */
    /* bottom: 0; */
    width: 100%;
    /* overflow-x: hidden; */
    /* overflow-y: auto; */
    padding: 32px 20px;
    bottom: 20px;
    /* height: calc(100% - 240px); */
    background-color: #fff;
    max-width: 970px;
    background: #fff;
    color: #4c4948;
    border-radius: 8px;
    box-shadow: 0 4px 8px 6px rgba(7, 17, 27, 0.06);
    margin: 160px auto 40px auto !important;
  }
  .contentImg {
    border-radius: 12px;
    width: 90%;
    margin: 10px;
  }
}
.barrage-items {
  border-radius: 80px 20px;
  padding: 5px 32px 5px 24px;
  align-items: center;
  display: flex;
  margin-bottom: 14px;
  width: fit-content;
}
.nickname {
  margin-left: 14px;
  font-size: 0.75rem;
  color: #777;
  margin-right: 0.75rem;
}
.datetime {
  font-size: 0.75rem;
  color: #777;
  margin-right: 0.75rem;
}
.fenge {
  padding: 10px 6px 2px 6px;
  border-left: 1px dashed #555;
  font-size: 0;
  margin: 3px 0px;
}
.content {
  margin-left: 14px;
}
.headRow {
  padding-bottom: 6px;
}
.contentDot {
  min-width: 8px;
  position: relative;
  float: bottom;
  left: 10px;
  margin-left: 10px;
  bottom: 0px;
  width: 8px;
  height: 8px;
  /* background: blue; */
  border-radius: 4px;
  box-shadow: 0px 0px 2px 2px rgb(234 234 234 / 17%);
}
.imageUploadBtn:hover,
.imagmessage-image-hover-icon:hover {
  cursor: url("~@/assets/images/pointer.png"), default;
}
.imagmessage-image-hover-icon {
  position: absolute;
  bottom: 6px;
  right: 6px;
  color: #777;
}
.contentRowImg {
  margin: 6px 2px;
}
.msgItemCol {
  left: 4px;
  position: relative;
  padding: 8px 2px;
}
.message-tip {
  font-size: 10px;
  bottom: 14px;
  font-style: italic;
  left: 4px;
  color: #aaa;
  margin-bottom: 4px;
  font-style: italic;
}
</style>
